import { FC, MouseEvent, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { Box, rem } from '@bonusly/design-system';

import { useLinkNavigation } from '../hooks/use-link-navigation';

const getStyle = (isActive: boolean) => {
	if (isActive) {
		return {
			bg: 'primary.bgAlpha',
			color: 'primary.fgStrong',
		};
	}

	return {
		bg: 'none',
		color: 'secondary.fg',
		_hover: { bg: 'secondary.bgAlpha' },
	};
};

type UserNavLinkProps = {
	children: ReactNode;
	isExpanded: boolean;
	isRecognizeRoute?: boolean;
	to: string;
};

export const UserNavLink: FC<UserNavLinkProps> = ({ children, to, isExpanded, isRecognizeRoute = false, ...props }) => {
	const { isCrossDomain, url } = useLinkNavigation({ path: to, isRecognizeRoute });

	const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
		if (isCrossDomain) {
			e.preventDefault();
			window.location.href = url;
		}
	};

	return (
		<NavLink to={url} onClick={handleClick} style={{ width: '100%' }} {...props}>
			{({ isActive }: { isActive: boolean }) => (
				<Box {...getStyle(isActive)} w="100%" py={rem(8)} px={isExpanded ? rem(10) : rem(8)} borderRadius="md">
					{children}
				</Box>
			)}
		</NavLink>
	);
};
